var map = {
	"./24Hours.vue": "eb66",
	"./AddToBasket.vue": "33c1",
	"./Approval.vue": "adce",
	"./ArrowDown.vue": "fce8",
	"./ArrowLeft.vue": "53df",
	"./ArrowRight.vue": "bf7e",
	"./ArrowUp.vue": "9146",
	"./Attachment.vue": "1b4f",
	"./Barcode.vue": "e7e6",
	"./Basket.vue": "7d86",
	"./Bin.vue": "dc0c",
	"./Bulb.vue": "a875",
	"./Calc.vue": "d59b",
	"./Calendar.vue": "9f38",
	"./Cancel.vue": "c296",
	"./CashRegister.vue": "f4e8",
	"./ChangePassword.vue": "e314",
	"./Check.vue": "d499",
	"./CheckCorrect.vue": "3317",
	"./CheckIncorrect.vue": "d440",
	"./Chevron.vue": "0aef",
	"./Circle.vue": "2850",
	"./CircleGray.vue": "7247",
	"./Clear.vue": "28cb",
	"./Close.vue": "e21f",
	"./Coin.vue": "8d66",
	"./Coins.vue": "1559",
	"./Consents.vue": "92c8",
	"./Copy.vue": "38c1",
	"./DiagnosticsError.vue": "9c8c",
	"./DiagnosticsOk.vue": "8986",
	"./Doc.vue": "76ba",
	"./Documents.vue": "f753",
	"./Download.vue": "e856",
	"./DownloadAttachment.vue": "2b09",
	"./Dropdown.vue": "6910",
	"./Edit.vue": "49f6",
	"./Envelope.vue": "7618",
	"./ErrorCircle.vue": "255e",
	"./Eye.vue": "8387",
	"./EyeClosed.vue": "fa9f",
	"./Facebook.vue": "0fba",
	"./Filter.vue": "1b4d",
	"./Heart.vue": "b8d7",
	"./Help.vue": "60c8",
	"./Hours.vue": "8de9",
	"./Info.vue": "1187",
	"./Instagram.vue": "f55a",
	"./InvalidMark.vue": "e65b",
	"./ItemPromotionalDiscount.vue": "205c",
	"./ItemPromotionalFree.vue": "fa58",
	"./ItemPromotionalPercentage.vue": "cf63",
	"./ItemPromotionalPrice.vue": "69f7",
	"./Left.vue": "2753",
	"./Logout.vue": "529a",
	"./Loupe.vue": "bf8b",
	"./Mail.vue": "e064",
	"./Manage.vue": "ce92",
	"./MarkAsUnread.vue": "1ed5",
	"./MyData.vue": "269a",
	"./NoImg.vue": "2f92",
	"./NoPhoto.vue": "5d63",
	"./NotificationBell.vue": "63a1",
	"./Ok.vue": "e029",
	"./PadlockDown.vue": "a022",
	"./PadlockUp.vue": "dc23",
	"./PaperPlane.vue": "8e5b",
	"./Pdf.vue": "ac110",
	"./Phone.vue": "14ee",
	"./Plus.vue": "86a6",
	"./PriceTags.vue": "b89a",
	"./Producenci.vue": "950e",
	"./Promo.vue": "f4bd",
	"./PromoList.vue": "bb6c",
	"./Promotions.vue": "bb7b",
	"./Pulpit.vue": "32e4",
	"./Report.vue": "9412",
	"./Right.vue": "b614",
	"./Rozliczenia.vue": "6a30",
	"./Save.vue": "a9bf",
	"./Scale.vue": "f079",
	"./Share.vue": "a814",
	"./Shop.vue": "24f1",
	"./SmokingSegment.vue": "a6ba",
	"./SortDown.vue": "6514",
	"./SortUp.vue": "56de",
	"./Spinner.vue": "0527",
	"./Statystyki.vue": "c53b",
	"./Success.vue": "244b",
	"./Upload.vue": "d35a",
	"./User.vue": "485d",
	"./UserAvatarMenuHidden.vue": "bcbe",
	"./UserAvatarMenuOpened.vue": "0b12",
	"./UsersManagement.vue": "1c7c",
	"./Uslugi.vue": "df9f",
	"./Warning.vue": "5224",
	"./WarningFull.vue": "6317",
	"./Website.vue": "491c",
	"./Xls.vue": "6390",
	"./Youtube.vue": "7aa5",
	"./Zip.vue": "26ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "19dd";